import { jsxs as s, jsx as n } from "react/jsx-runtime";
import { useTranslation as c } from "react-i18next";
import o from "./mobile-menu-action-bar.module.less.js";
const m = ({ onClickBack: t, onClickClose: i }) => {
  const { t: a } = c();
  return /* @__PURE__ */ s("div", { className: o.actionBarWrapper, children: [
    typeof t == "function" && /* @__PURE__ */ n("button", { onClick: t, className: [o.actionButton].join(" "), children: /* @__PURE__ */ n("span", { className: [o.icon, o.iconBack, "ui-icon-arrow-left"].join(" ") }) }),
    typeof i == "function" && /* @__PURE__ */ s("button", { onClick: i, className: [o.actionButton, o.closeButton].join(" "), children: [
      /* @__PURE__ */ n("span", { className: [o.icon, o.iconClose, "ui-icon-close"].join(" ") }),
      /* @__PURE__ */ n("div", { className: "body-base mb-0", children: a("CLOSE") })
    ] })
  ] });
};
export {
  m as default
};
